import FileInputV3 from '@efex-components/EfexDS/FileInput/FileInput';
import { OnboardingDocumentTypeIds } from '@efex-services/documents/types';
import {
  Alert,
  AlertTitle,
  Typography,
  Checkbox,
  FormControlLabel,
  FormControl,
  FormGroup,
  FormLabel,
  Grid,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { capitalizeFirst } from '@utils/formater';
import { UseFileServiceReturn } from '@efex-components/EfexDS/FileInput/types/useFileService.type';
import useFileService from '@efex-components/EfexDS/FileInput/useFileService';
import useBussinesNature from './useBussinesNature';
import { NatureOfBusinessOptions } from './bussinesNature.config';

const BussinesNature = ({
  useExistingFileService,
}: {
  useExistingFileService?: UseFileServiceReturn;
}) => {
  const { t } = useTranslation();

  const defaultFileService = useFileService();

  const fileServiceToUse = useExistingFileService || defaultFileService;

  const {
    onboardingDocuments,
    errorUploadDocuments: error,
    handleChangeFile,
    handleDeleteFile,
    handleDropChangeFile,
  } = fileServiceToUse;

  const { showBusinessNature, handleCheckboxChange } = useBussinesNature({
    onboardingDocuments,
  });

  return (
    <Grid container flexDirection={{ xs: 'column' }}>
      <FormControl component="fieldset">
        <FormLabel component="legend">
          <Typography color="black" variant="h6">
            {t('onbNatureOfBusinessQuestion')}
          </Typography>
        </FormLabel>
        <FormGroup row>
          {[NatureOfBusinessOptions.YES, NatureOfBusinessOptions.NO].map(
            (option) => (
              <FormControlLabel
                key={option}
                control={
                  <Checkbox
                    checked={
                      showBusinessNature[option as NatureOfBusinessOptions]
                    }
                    onChange={handleCheckboxChange}
                    name={option}
                  />
                }
                label={t(
                  `onbNatureOfBusinessQuestion${capitalizeFirst(option)}Option`
                )}
              />
            )
          )}
        </FormGroup>
      </FormControl>

      {showBusinessNature.yes && (
        <>
          <Alert severity="info" variant="outlined">
            <AlertTitle>{t('onbNatureOfBusiness')}</AlertTitle>
            <Typography variant="body2" className="!mb-2">
              {t('onbNatureOfBusinessSubtitle')}
            </Typography>
            <Typography component="p" variant="caption">
              {t('onbNatureOfBusinessOption1')}
            </Typography>
            <Typography component="p" variant="caption">
              {t('onbNatureOfBusinessOption2')}
            </Typography>
          </Alert>
          <FileInputV3
            inputName="businessNature"
            onChange={handleChangeFile}
            onDropChange={handleDropChangeFile}
            onDelete={handleDeleteFile}
            error={error}
            documents={onboardingDocuments?.filter(
              (element) =>
                element.document.type.id ===
                OnboardingDocumentTypeIds.businessNature
            )}
          />
        </>
      )}
    </Grid>
  );
};

export default BussinesNature;
